import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfig } from '../../app-config';
import { tap, groupBy } from 'rxjs/operators';
import { TokenStorageService } from '../auth/token-storage.service';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  observe: 'response' as 'body'
};

@Injectable({
  providedIn: 'root'
})
export class ClientesService {

  AUTH_API = "";

  constructor(private http: HttpClient,
              private tokenStorage: TokenStorageService,
              private appConfig:AppConfig
              ) {
                this.AUTH_API = appConfig.api_url;
              }

  getAll(): Observable<any> {
    return this.http.get(this.AUTH_API + 'cliente/all', httpOptions).pipe(tap(empresas => {
      return empresas;
    }));
  }

  getAllBySujetoObligado(sujeto, page, pageSize): Observable<any> {
    return this.http.post(this.AUTH_API + 'cliente/sujeto-obligado/'+sujeto+'/all?pagina='+page+'&cantidad='+pageSize,{}, httpOptions).pipe(tap(objetivos => {
      return objetivos;
    }));
  }

  add(cliente): Observable<any> {
    return this.http.post(this.AUTH_API + 'cliente/add', cliente, httpOptions);
  }

  get(clienteId): Observable<any> {
    return this.http.get(this.AUTH_API + `cliente/${clienteId}`).pipe(tap(audits => {
      return audits;
    }));
  }

  delete(id): Observable<any> {
    return this.http.delete(this.AUTH_API + 'cliente/' + id, httpOptions);
  }

  getByUUID(uuid): Observable<any> {
    return this.http.get(this.AUTH_API + `cliente/uuid/${uuid}`).pipe(tap(audits => {
      return audits;
    }));
  }

  getByUTAccess(utaccess): Observable<any> {
    return this.http.get(this.AUTH_API + `cliente/utaccess/${utaccess}/external`).pipe(tap(audits => {
      return audits;
    }));
  }

  getDebidasDiligencias(clienteId, page, pageSize): Observable<any> {
    return this.http.get(this.AUTH_API + `cliente/${clienteId}/debida-diligencia`).pipe(tap(audits => {
      return audits;
    }));
  }

  getAccionistas(clienteId): Observable<any> {
    return this.http.get(this.AUTH_API + `cliente/${clienteId}/accionistas`, httpOptions).pipe(tap(accionistas => {
      return accionistas;
    }));
  }

  addAccionista(id,accionista): Observable<any> {
    return this.http.post(this.AUTH_API + `cliente/${id}/accionistas/add`, accionista, httpOptions);
  }

  editAccionista(id, idAccionista, accionista): Observable<any> {
    return this.http.put(this.AUTH_API + `cliente/${id}/accionistas/${idAccionista}`, accionista, httpOptions);
  }

  deleteAccionista(id, idAccionista): Observable<any> {
    return this.http.delete(this.AUTH_API + `cliente/${id}/accionistas/${idAccionista}`, httpOptions);
  }

  edit(id, cliente): Observable<any> {
    return this.http.put(this.AUTH_API + 'cliente/' + id, cliente
    , httpOptions);
  }

  editExternal(id, cliente): Observable<any> {
    return this.http.put(this.AUTH_API + 'cliente/' + id+"/update", cliente, httpOptions);
  }

  

  generateUTAccess(clienteId): Observable<any> {
    return this.http.get(this.AUTH_API + `cliente/${clienteId}/generate/utaccess`, httpOptions).pipe(tap(cantidad => {
      return cantidad;
    }));
  }
  
}
